import { Box } from "@mui/material";

import TimelineCell from "./TimelineCell";

import { CELL_GAP } from "../constants/timelineConstants";
import dayjs from "dayjs";

export default function TimelineRowCells({
  row,
  weeks,
  holidayWeeks,
  color,
  dialogs,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: `${CELL_GAP}px`,
      }}
    >
      {weeks.map((week, weekIndex) => {
        const isCurrentWeek = dayjs().isSame(week, "week");
        const isHoliday = Boolean(holidayWeeks?.[week.format("YYYY-MM-DD")]);
        const holiday = holidayWeeks[week.format("YYYY-MM-DD")];
        const activeProjects = row.projects.filter(
          (project) =>
            weekIndex >= project.startWeek && weekIndex <= project.endWeek,
        );

        const deadlineProject = row.projects.find(
          (project) => project.evaluation && weekIndex === project.endWeek,
        );

        const active = activeProjects.length > 0;

        const tooltip = holiday
          ? holiday.title
          : activeProjects
              .map(
                (project) =>
                  `${project.title}${project.evaluation ? " ✅" : ""}`,
              )
              .join("\n");

        return (
          <TimelineCell
            key={weekIndex}
            active={active}
            deadline={Boolean(deadlineProject)}
            holiday={isHoliday}
            color={color}
            tooltip={tooltip}
            isCurrentWeek={isCurrentWeek}
            onClick={() => {
              if (activeProjects.length > 0) {
                dialogs.openEditProject({
                  project: activeProjects[0],

                  subject: row.subjectName,

                  week,

                  classData: {
                    id: row.classId,
                    name: row.className,
                  },
                });
              } else {
                dialogs.openCreateProject({
                  subject: row.subjectName,

                  week,

                  classData: {
                    id: row.classId,
                    name: row.className,
                  },
                });
              }
            }}
          />
        );
      })}
    </Box>
  );
}
